import {
  HttpClient,
  HttpErrorResponse,
  HttpEvent,
  HttpHeaders,
  HttpParams
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { ApiError } from '../../models/api-error.model';
import { AppSettingsService } from '../app-settings/app-settings.service';

@Injectable({
  providedIn: 'root'
})
export class ApiService {
  constructor(
    protected httpClient: HttpClient,
    private appSettingsService: AppSettingsService
  ) { }

  private formatErrors(error: HttpErrorResponse): Observable<never> {
    const finalError = error.error ? error.error : error;
    const apiError = new ApiError(
      error.status,
      finalError.code,
      finalError.message
    );
    return throwError(apiError);
  }

  get<T>(path: string, options: HttpOptions = {}): Observable<T> {
    return this.httpClient
      .get<T>(
        `${this.appSettingsService.configuration.webApi.uri}${path}`,
        options
      )
      .pipe(catchError(this.formatErrors));
  }

  put<T>(
    path: string,
    body: object = {},
    options: HttpOptions = {}
  ): Observable<T> {
    return this.httpClient
      .put<T>(
        `${this.appSettingsService.configuration.webApi.uri}${path}`,
        body,
        options
      )
      .pipe(catchError(this.formatErrors));
  }

  patch<T>(
    path: string,
    body: object = {},
    options: HttpOptions = {}
  ): Observable<T> {
    return this.httpClient
      .patch<T>(
        `${this.appSettingsService.configuration.webApi.uri}${path}`,
        body,
        options
      )
      .pipe(catchError(this.formatErrors));
  }

  post<T>(
    path: string,
    body: object = {},
    options: HttpOptions = {}
  ): Observable<T> {
    return this.httpClient
      .post<T>(
        `${this.appSettingsService.configuration.webApi.uri}${path}`,
        body,
        options
      )
      .pipe(catchError(this.formatErrors));
  }

  postBinary<T>(
    path: string,
    formData: FormData,
    _options: {
      headers?:
      | HttpHeaders
      | {
        [header: string]: string | string[];
      };
      observe: 'events';
      params?:
      | HttpParams
      | {
        [param: string]: string | string[];
      };
      reportProgress?: boolean;
      responseType?: 'json';
      withCredentials?: boolean;
    }
  ): Observable<T | HttpEvent<T>> {
    return this.httpClient
      .post<T>(
        `${this.appSettingsService.configuration.webApi.uri}${path}`,
        formData,
        {
          reportProgress: true,
          observe: 'events'
        }
      )
      .pipe(catchError(this.formatErrors));
  }

  delete(path, options: HttpOptions = {}): Observable<any> {
    return this.httpClient
      .delete(
        `${this.appSettingsService.configuration.webApi.uri}${path}`,
        options
      )
      .pipe(catchError(this.formatErrors));
  }
}

export interface HttpOptions {
  headers?:
  | HttpHeaders
  | {
    [header: string]: string | string[];
  };
  observe?: 'body';
  params?:
  | HttpParams
  | {
    [param: string]: string | string[];
  };
  reportProgress?: boolean;
  responseType?: any;
  withCredentials?: boolean;
}
